import { render, staticRenderFns } from "./ModalAreaUniversidad.vue?vue&type=template&id=691ecb54"
import script from "./ModalAreaUniversidad.vue?vue&type=script&lang=js"
export * from "./ModalAreaUniversidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports